import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

const CloseButton = forwardRef(({ title = 'Close', ...props }, ref) => (
  <BaseButton
    ref={ref}
    responsive
    id='close-button'
    icon='close'
    title={title}
    {...props}
  />
));

export default CloseButton;
